
<script>
import BarList from '../components/bar-list'
import SerienfForm from './serienf-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codserienf: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        serienfList: function () {
            return this.$store.getters.getSerienfList
        },
        nextPage: function () {
            return this.$store.getters.getNextPage
        }
    },

    filters: {
        getText: function (value, metadata) {
            return getText(value, metadata)
        },

    },

    methods: {
        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codserienf = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codserienf = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"serie":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadSerienf', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        }

    },

    components: {
        BarList, SerienfForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Serie de NF" 
                plural-entity="Séries de NF"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela série da nota">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="serienfList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="serienf in serienfList" v-bind:key="serienf.codserienf">
                    <div class="mark-green"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-3" style="float: left">
                                <label class="lbl-list"> {{metadata.serienf.codfil.label}} </label><span class="data-list">{{ serienf.codfil }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list"> {{metadata.serienf.serie.label}} </label><span class="data-list">{{ serienf.serie }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list"> {{metadata.serienf.nf.label}} </label><span class="data-list">{{ serienf.nf }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list"> {{metadata.serienf.esp.label}} </label><span class="data-list">{{ serienf.esp }}</span>
                            </div>
                            <div class="col-md-2 col-12">
                                <bar-grid 
                                    :options="{barDefault: true, btnView: false, btnEdit: true}" 
                                    :moreActions="[]" 
                                    v-on:edit="handleEdit(serienf.codserienf)" 
                                    v-on:view="handleEdit(serienf.codserienf, true)">
                                </bar-grid>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <serienf-form v-if="showForm" :index="this.codserienf" :crud="this.crud" v-on:closeform="closeForm"></serienf-form>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/serienf-list.vue